export default "__VITE_ASSET__DV30tyLA__"